import Pimprenelle from './pimprenelle.svg?react'
import Ratp from './ratp.svg?react'
import AddCircle from './add-circle.svg?react'
import CheckCircle from './check-circle.svg?react'
import Close from './close.svg?react'
import ArrowRight from './arrow-right.svg?react'
import Alert from './alert.svg?react'
import ChevronLeft from './chevron-left.svg?react'
import ChevronRight from './chevron-right.svg?react'
import ChevronDown from './chevron-down.svg?react'
import ChevronUp from './chevron-up.svg?react'
import Loading from './loading.svg?react'
import PlusCircle from './plus-circle.svg?react'
import MinusCircle from './minus-circle.svg?react'
import Trash from './trash.svg?react'
import Email from './email.svg?react'
import ExclamationCircle from './exclamation-circle.svg?react'
import Checkbox from './check-box.svg?react'
import CheckedBox from './checked-box.svg?react'
import Record from './record.svg?react'
import CreditCard from './credit-card.svg?react'
import Setting from './settings.svg?react'
import Check from './check.svg?react'
import ArrowUp from './arrow-up.svg?react'
import ArrowDown from './arrow-down.svg?react'
import Shutdown from './shutdown.svg?react'
import SortUp from './sort-up.svg?react'
import SortDown from './sort-down.svg?react'
import Payment from './payment.svg?react'
import Control from './control.svg?react'
import Look from './look.svg?react'
import File from './file.svg?react'
import Eye from './eye.svg?react'
import Loop from './loop.svg?react'
import CloseCircle from './close-circle.svg?react'
import People from './people.svg?react'
import DashCircle from './dash-circle.svg?react'
import AuditOk from './audit-ok.svg?react'
import AuditKo from './audit-ko.svg?react'

const svgs = {
  pimprenelle: Pimprenelle,
  ratp: Ratp,
  add_circle: AddCircle,
  // check: Check,
  plus_circle: PlusCircle,
  minus_circle: MinusCircle,
  trash: Trash,
  loading: Loading,
  // loading_inverse: LoadingWhite,
  check_circle: CheckCircle,
  arrow_right: ArrowRight,
  arrow_up: ArrowUp,
  arrow_down: ArrowDown,
  close: Close,
  alert: Alert,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  chevron_down: ChevronDown,
  chevron_up: ChevronUp,
  email: Email,
  exclamation_circle: ExclamationCircle,
  checkbox: Checkbox,
  checkedbox: CheckedBox,
  record: Record,
  credit_card: CreditCard,
  setting: Setting,
  check: Check,
  shutdown: Shutdown,
  sort_up: SortUp,
  sort_down: SortDown,
  payment: Payment,
  control: Control,
  look: Look,
  file: File,
  eye: Eye,
  loop: Loop,
  close_circle: CloseCircle,
  dash_circle: DashCircle,
  // edit: Edit
  people: People,
  audit_ok: AuditOk,
  audit_ko: AuditKo
}

const getSrc = (key) => {
  return svgs[key] ? svgs[key] : key
}

export default svgs
export { getSrc }
